// import React from "react";
// import { useSelector } from "react-redux";
// import { Navigate, Outlet } from "react-router-dom";

// export const ProtectedRoute = ({ allowedRoles = [] }) => {
//   const { isAuthenticated, role } = useSelector((state) => state.auth);
  
//   if (!isAuthenticated) return <Navigate to="/accounts" replace />;
  
//   if (allowedRoles.length && (!role || !allowedRoles.includes(role))) {
//     return <Navigate to="/unauthorized" replace />;
//   }
  
//   return <Outlet />;
// };


// import React from "react";
// import { useSelector } from "react-redux";
// import { Navigate, Outlet } from "react-router-dom";


// export const ProtectedRoute = ({ allowedRoles = [] }) => {
//   const { isAuthenticated, role } = useSelector(state => state.auth);

//   if (!isAuthenticated) return <Navigate to="/accounts" replace />;
//   if (allowedRoles.length && (!role || !allowedRoles.includes(role))) {
//     return <Navigate to="/unauthorized" replace />;
//   }
//   return <Outlet />;
// };


import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { isAuthenticated, role, loading } = useSelector(state => state.auth);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/accounts" replace />;
  }

  if (allowedRoles.length && (!role || !allowedRoles.includes(role))) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

